module.exports = __webpack_public_path__ + "static/media/view maintenance report.b93f33be.svg";